/**
 * Where an uploaded asset is served: the Worker's `content.get("/assets/:key")`,
 * mounted under `/api` on the same origin as the storefront and the admin.
 * Every page and screen that shows an upload builds its URL here.
 */
export const ASSET_PATH_PREFIX = "/api/assets/";
export const assetPath = (key) => `${ASSET_PATH_PREFIX}${encodeURIComponent(key)}`;
//# sourceMappingURL=assets.js.map